import { render, staticRenderFns } from "./requestKits.vue?vue&type=template&id=449f4ff9"
import script from "./requestKits.vue?vue&type=script&lang=js"
export * from "./requestKits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports